function updateURLParameters() {
  let e = new URLSearchParams(window.location.search),
    t = document.querySelectorAll(".filter-checkbox"),
    a = document.querySelectorAll(".sort-checkbox");
  t.forEach((t) => {
    let a = t.getAttribute("data-param-name");
    e.delete(a);
  }),
    t.forEach((t) => {
      if (t.checked) {
        let a = t.getAttribute("data-param-name"),
          r = t.getAttribute("data-param-value");
        e.append(a, r);
      }
    }),
    e.delete("sort_by"),
    a.forEach((t) => {
      if (t.checked) {
        let a = t.getAttribute("data-param-name"),
          r = t.getAttribute("data-param-value");
        e.set(a, r);
      }
    });
  let r = `${window.location.pathname}?${e.toString()}`;
  window.history.pushState({}, "", r), fetchFilteredCollection(r);
}
function updateLabelClass(e) {
  let t = e.parentNode;
  e.checked ? t.classList.add("checked") : t.classList.remove("checked");
}
document.addEventListener("DOMContentLoaded", () => {
  let e = document.querySelectorAll(".filter-checkbox"),
    t = document.querySelectorAll(".sort-checkbox");
  e.forEach((e) => {
    e.addEventListener("change", () => {
      updateURLParameters(), updateLabelClass(e);
    });
  }),
    t.forEach((e) => {
      e.addEventListener("change", () => {
        t.forEach((t) => {
          t !== e && ((t.checked = !1), updateLabelClass(t));
        }),
          updateURLParameters(),
          updateLabelClass(e);
      });
    });
  let a = new URLSearchParams(window.location.search);
  e.forEach((e) => {
    let t = e.getAttribute("data-param-name"),
      r = e.getAttribute("data-param-value");
    a.getAll(t).includes(r) && ((e.checked = !0), updateLabelClass(e));
  }),
    t.forEach((e) => {
      let t = e.getAttribute("data-param-name"),
        r = e.getAttribute("data-param-value");
      a.getAll(t).includes(r) && ((e.checked = !0), updateLabelClass(e));
    });
}),
  document.addEventListener("DOMContentLoaded", () => {
  let giftNoteButton = document.querySelector(".gift-note-message");

  if (giftNoteButton) {
    giftNoteButton.addEventListener("click", function (e) {
      e.preventDefault();
      let accordionItem = document.querySelector(".accordion-item.js-minicartnote.closed");
      if (accordionItem) {
        accordionItem.classList.remove("closed");
      }
    });
  }
});

